import React from 'react';
import {
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    SelectChangeEvent,
    SelectProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const activeDropdownOptions = [
    { label: 'Active', value: 'Active', id: 1 },
    { label: 'Inactive', value: 'Inactive', id: 2 },
];

// Custom styled select
const StyledSelect = styled(Select)<{ currentvalue: string, disabled?: boolean }>(({ currentvalue }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
        border: currentvalue === 'Active'
            ? '1px solid #2E7D32 !important'
            : '1px solid red !important',
    },
    '& .MuiSelect-icon': {
        color: currentvalue === 'Active' ? '#2E7D32' : 'red',
    },

    '& .MuiSelect-select': {
        color: currentvalue === 'Active' ? '#2E7D32' : 'red',
    },
}));

type Props = {
    selectedStatus: string;
    setSelectedStatus: (val: string) => void;
    viewRule?:boolean
};

const CustomSelectInputComponent: React.FC<Props> = ({ selectedStatus, setSelectedStatus,viewRule=false }) => {
    const handleChange = (event: any) => {
        setSelectedStatus(event?.target?.value);
    };

    return (
        <FormControl fullWidth>
            <StyledSelect
                currentvalue={selectedStatus}
                value={selectedStatus}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                disabled={viewRule}
            >
                {activeDropdownOptions.map((option) => (
                    <MenuItem key={option.id} value={option.value} sx={{
                        color: option.value === 'Active' ? '#2E7D32' : 'red',
                    }} >
                        {option.label}
                    </MenuItem>
                ))}
            </StyledSelect>
        </FormControl>
    );
};

export default CustomSelectInputComponent;
